import PortfolioPlaceholderCards from './PortfolioPlaceholderCards.component';

export default PortfolioPlaceholderCards;
